import './footer.scss'

export const Footer = () => <footer>
    <span>2022 </span>
    <span><a href="https://github.com/yzAlvin/" target="_blank" rel="noreferrer">Alvin Zhao</a></span>
</footer>